import {
  Box,
  FormControl,
  Grid,
  Grid2,
  IconButton,
  MenuItem,
  Popover,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import {
  checkGuestLimit,
  setGuestCount,
  updateActivityDuration,
  updateReservationType,
  updateSelectedDate,
  updateTime,
  updateTotalCount,
} from "../../store/slice/Activity.slice";

import { useTheme } from "@emotion/react";

const Addguest = ({ isOpen, handleClose, Ref, activityData }) => {
  const { css } = useSelector((store) => store?.widgetSettings);
  const guestsCss = css?.find((item) => item?.cssTabFieldsGroupName === "Guests")?.fields;
  const [anchorOriginVert, setAnchorOriginVert] = useState("bottom"); // default
  const [transformOriginVert, setTransformOriginVert] = useState("top"); // default
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("sm");
  const { adult, isGreaterThan10, languageWords } = useSelector(
    (store) => store.Activity
  );
  const dispatch = useDispatch();
  const { widgetConfig } = activityData;
  const nonEmptyFields = Object.keys({})
    .filter(
      (key) =>
        key.startsWith("field") && widgetConfig?.fields[key].trim() !== ""
    )
    .map((key) => widgetConfig?.fields[key]);
  useEffect(() => {
    dispatch(updateTotalCount(adult));
  }, [adult]);
  const resetField = () => {
    dispatch(updateSelectedDate(""));
    dispatch(updateReservationType({}));
    dispatch(updateTime(""));
    dispatch(updateActivityDuration(""));
  };

  useEffect(() => {
    if (Ref?.current) {
      const rect = Ref.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.bottom + 400 > viewportHeight) {
        // 400 ~ popover height
        setAnchorOriginVert("top");
        setTransformOriginVert("bottom");
      } else {
        setAnchorOriginVert("bottom");
        setTransformOriginVert("top");
      }
    }
  }, [isOpen, Ref]);

  if (
    !nonEmptyFields ||
    nonEmptyFields.length == 1 ||
    nonEmptyFields.length == 0
  ) {
    return (
      <>
        <Popover
          open={isOpen}
          anchorEl={Ref?.current}
          onClose={handleClose}
          anchorOrigin={{
            vertical: anchorOriginVert,
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: transformOriginVert,
            horizontal: "center",
          }}
          disableAutoFocus
          disableEnforceFocus
          disableRestoreFocus
          PaperProps={{
            sx: {
              backgroundColor:   guestsCss?.GuestBackgroundColor,
              maxHeight: 600,
              borderRadius: 2,
              boxShadow: 6,
              p: 2,
              width: 200,
              overflow: "hidden",
            },
            onWheel: (e) => e.stopPropagation(), // iframe fix
          }}
        >


          <Grid item xs={12}>
            {/* Header */}
            <Typography
              sx={{
                fontSize: "13px",
                mb: 1,
                color: guestsCss?.GuestHeaderTextColor,
              }}
            >
              {languageWords?.Guest}
            </Typography>

            {/* Counter ( >10 mode ) */}
            {isGreaterThan10?.adult ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: `1px solid ${guestsCss?.GuestDropDownBorderColor}`,
                  borderRadius: 1,
                  px: 2,
                  py: 1,
                  mb: 2,
                }}
              >
                <IconButton
                  onClick={() => {
                    if (adult > 1) {
                      resetField();
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: adult - 1,
                        })
                      );
                    }
                  }}
                >
                  <RemoveCircleIcon  sx={{ color: guestsCss?.decrementColorIcon }}/>
                </IconButton>

                <Typography fontSize={16}>{adult}</Typography>

                <IconButton
                  onClick={() => {
                    resetField();
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: adult + 1,
                      })
                    );
                  }}
                >
                  <AddCircleOutlineIcon  sx={{ color: guestsCss?.incrementIconClr }}  />
                </IconButton>
              </Box>
            ) : (
              <>
                {/* Dropdown list */}
                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",

                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      width: "100%",
                      gap: 1,
                    }}
                  >
                    {[...Array(9)].map((_, index) => {
                      const value = index + 1;
                      const isActive = adult === value;

                      return (
                        <Box
                          key={value}
                          onClick={() => {
                            resetField();
                            dispatch(
                              setGuestCount({
                                guestType: "adult",
                                count: value,
                              })
                            );
                            handleClose();
                          }}
                          sx={{
                            height: 44,
                            px: 2,
                            border: `1px dashed ${guestsCss?.GuestDropDownBorderColor}`,
                            mb: 0.5,
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            display:"flex",
                            justifyContent:'center',
                            alignItems:"center",
                        
                            backgroundColor: isActive ?
                            `#${guestsCss?.selectGuestBg}` : guestsCss?.GuestDropDownBackgroundColor,

                            color: isActive
                              ?  `#${guestsCss?.selectGuestTxtClr}` : guestsCss?.GuestDropDownTextColor,

                              "&:hover": {
                                backgroundColor: guestsCss?.GuestDropDownBackgroundColorHover,
                                color: guestsCss?.GuestDropDownTextColorHover,
                              },
                          }}
                        >
                          <Typography fontSize={18} >{value}</Typography>
                        </Box>
                      );
                    })}
                    <Box
                      onClick={() => {
                        dispatch(
                          checkGuestLimit({
                            guestType: "adult",
                            isGreaterThan10: true,
                          })
                        );
                        dispatch(
                          setGuestCount({
                            guestType: "adult",
                            count: 11,
                          })
                        );
                        handleClose();
                      }}
                      sx={{
                      
                        px: 2,
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        borderRadius: 1.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        cursor: "pointer",
                        transition: "0.2s",
                        border: `1px dashed ${guestsCss?.GuestDropDownBorderColor}`,

                        "&:hover": {
                          backgroundColor: theme?.guest?.dropdownBgHover,
                        },
                      }}
                    >
                         <AddCircleOutlineIcon
                    sx={{ color: guestsCss?.plusColor,"&:hover": { color: guestsCss?.plusHover } }}
                    fontSize="large"
                  />
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Grid>
        </Popover>
      </>
    );
  }
  return (
    <Popover
      open={isOpen}
      anchorEl={Ref?.current} // ✅ VERY IMPORTANT
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
           backgroundColor: guestsCss?.GuestBackgroundColor,
          width: isSmallScreen ? "100%" : "290px",
          maxWidth: "430px",
        },
      }}
    >
      <Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mx: 3,
            }}
          >
            <FormControl fullWidth sx={{ width: "100%", height: "32px" }}>
              {isGreaterThan10?.adult ? (
                <TextField
                  name="adult"
                  value={adult} // Show value adjusted for base of 10
                  type="number"
                  // Prevent the Select from closing
                  onClick={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                  sx={{
                    width: "100%",
                    height: "30px",
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      color:  guestsCss?.GuestTextColor,
                    },
                  }}
                  size="small"
                  onChange={(e) => {
                    // e.preventDefault()
                    const inputValue = e.target.value;
                    const newValue = Number(inputValue);
                    resetField();

                    // Update state only if the input is a valid number
                    if (!isNaN(newValue) && inputValue.trim() !== "") {
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: newValue,
                        })
                      );
                    } else if (inputValue === "") {
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: 0,
                        })
                      );
                    }
                  }}
                />
              ) : (
                <Select
                  id="demo-simple-select"
                  value={adult}
                  size="small"
                  IconComponent={KeyboardArrowDownIcon} // Custom arrow icon
                  sx={{
                    width: "100%",

                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme?.guest?.dropdownBorderColor,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme?.guest?.dropdownBorderColor,
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      color: theme?.guest?.textColor,
                      fontSize: { sm: "12px" },
                    },
                  }}
                  onChange={(event) => {
                    resetField();
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: Number(event.target.value),
                      })
                    );
                  }}
                >
                  {new Array(10).fill(null).map((_, index) => (
                    <MenuItem
                      key={index}
                      value={index + 1}
                      sx={{
                        color: theme?.guest?.dropdownTextColor,
                        height: "100%",
                        fontSize: { sm: "12px" },
                        "&:hover": {
                          backgroundColor: theme?.guest?.dropdownBgHover,
                          color: theme?.guest?.dropdownTextColorHover,
                        },
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mx: 0.5,
                    }}
                  >
                    <Typography
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent the Select from closing
                        dispatch(
                          checkGuestLimit({
                            guestType: "adult",
                            isGreaterThan10: !isGreaterThan10?.adult,
                          })
                        );
                      }}
                    >
                      +
                    </Typography>
                  </MenuItem>
                </Select>
              )}
            </FormControl>
          </Box>
        </Box>
      </Box>
    </Popover>
  );
};

export default Addguest;
